
export default function api(app)
{

    app.events.on('kx_dropdownSelect:api_membership_id', function(event){
        $(event.el).parents('.form-field').next().find('.f-field').val(event.value)
    })
}
